import initializeComponent from '../react-initialize';
import Announcements from './announcements';

initializeComponent('Announcements', Announcements);
